import { ReactElement } from 'react'

interface Props {
  width: number
  color: string
}

const DevelopusCyrcle = ({ width, color }: Props): ReactElement => {
  return (
    <div
      style={{
        width: width,
        height: width,
        backgroundColor: color,
        borderRadius: '50%',
        marginLeft: 'auto',
      }}
    ></div>
  )
}

export default DevelopusCyrcle
